import { ObjectiveDto } from '../../../types'
import { BonusDistributionObjective } from './types'

export const formatObjectives = (objectives: ObjectiveDto[], distributionAmount: number): BonusDistributionObjective[] => {
  const isDistributionPositive = distributionAmount > 0

  let formatedObjectives = objectives.map((objective) => ({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    globalId: objective.globalId!,
    title: objective.title,
    currentBonus: objective.targetAmount ? objective.targetAmount : 0,
    changeAmount: 0,
  }))

  if (isDistributionPositive) {
    formatedObjectives = distributeEqually(formatedObjectives, distributionAmount)
  }
  return formatedObjectives
}

export const distributeEqually = (objectives: BonusDistributionObjective[], distributionAmount: number): BonusDistributionObjective[] => {
  const distributionAmountAbs = Math.abs(distributionAmount)

  const value = parseFloatOnTwoDecimals(distributionAmountAbs / objectives.length)

  const valueForLastElement = (distributionAmountAbs * 100 - Math.floor(value * (objectives.length - 1) * 100)) / 100
  const parsedValueForLastElement = parseFloatOnTwoDecimals(valueForLastElement)

  const objectivesWithDistributedAmount = objectives.map((x) => ({ ...x, changeAmount: value }))

  objectivesWithDistributedAmount[objectivesWithDistributedAmount.length - 1].changeAmount = parsedValueForLastElement

  return objectivesWithDistributedAmount
}

export const parseFloatOnTwoDecimals = (amount: number): number => parseFloat(Number(amount).toFixed(2))
